import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	schedules: {
		id: 'eoc-schedule.ui.section.schedules',
		defaultMessage: 'Schedules',
		description: 'Schedules message.',
	},
	createSchedule: {
		id: 'eoc-schedule.ui.section.create-schedule',
		defaultMessage: 'Create schedule',
		description: 'Tooltip of an icon to add new schedule.',
	},
	createNewSchedule: {
		id: 'eoc-schedule.ui.section.create-new-schedule',
		defaultMessage: 'Create a new schedule',
		description: 'Label for icon to add new schedule.',
	},
	preferences: {
		id: 'eoc-schedule.ui.section.preferences',
		defaultMessage: 'Preferences for schedules',
		description: 'An icon for schedule preferences.',
	},
	displayDensity: {
		id: 'eoc-schedule.ui.section.display-density',
		defaultMessage: 'Display density',
		description: 'Display density options of schedules.',
	},
	slim: {
		id: 'eoc-schedule.ui.section.slim',
		defaultMessage: 'Slim',
		description: 'Slim view option for schedule cards.',
	},
	comfort: {
		id: 'eoc-schedule.ui.section.comfort',
		defaultMessage: 'Comfort',
		description: 'Comfort view option for schedule cards.',
	},
	layout: {
		id: 'eoc-schedule.ui.section.layout',
		defaultMessage: 'Layout',
		description: 'Layout options of schedules.',
	},
	scheduleOrder: {
		id: 'eoc-schedule.ui.section.schedule-order',
		defaultMessage: 'Schedule order',
		description: 'Schedule order view options.',
	},
	finalScheduleOnTop: {
		id: 'eoc-schedule.ui.section.final-schedule-on-top',
		defaultMessage: 'Final schedule on top',
		description: 'Display final schedule on top view option.',
	},
	baseScheduleOnTop: {
		id: 'eoc-schedule.ui.section.base-schedule-on-top',
		defaultMessage: 'Base schedule on top',
		description: 'Display base schedule on top view option.',
	},
	gaps: {
		id: 'eoc-schedule.ui.section.gaps',
		defaultMessage: 'Gaps',
		description: 'Gaps view option for schedule.',
	},
	showGaps: {
		id: 'eoc-schedule.ui.section.show-gaps',
		defaultMessage: 'Show gaps',
		description: 'Show schedule gaps.',
	},
});
